export enum DESIGN_SCHEME_WIZARD_STEP {
    step1 = 0,
    step2 = 1,
    step3 = 2,
    step4 = 3,
    step5 = 4,
    step6 = 5,
    step7 = 6,
}
